import { useCallback, useMemo } from "react";

import { refundInitiationTableColumnsConfig } from "./refundInitiationTableColumnsConfig";

import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRefundInitiationState } from "../../../store/refund_initiation/refundFilterSlice";
import {
  selectRefundInitiations,
  useGetRefundInitiationListQuery,
} from "../../../services/refund_initiation/refundInitiationApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const RefundInitiationTablePage = () => {
  const appliedFilters = useSelector(selectRefundInitiationState);
  const { isSuccess, isLoading, isFetching } =
    useGetRefundInitiationListQuery(appliedFilters);

  const tableData = useSelector(selectRefundInitiations);
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (refundInitiationId) => {
      navigate(`/refund_payments/${refundInitiationId}`);
    },
    [navigate],
  );
  const columnDefs = useMemo(
    () => refundInitiationTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail],
  );

  return isSuccess ? (
    <Table data={tableData} columns={columnDefs} loading={isLoading || isFetching} />
  ) : (
    <CategoryPageSkeleton />
  );
};
